import { useState, useEffect } from "react";

const LABELS = {
  ui_audience_selected: (m) => `Picked audience: ${m.segment || "?"}${m.source === "form" ? " (via the form)" : ""}`,
  ui_legal_question_opened: (m) => `Opened legal question: ${m.question || "?"}`,
  ui_qualified_engagement: (m) => `Crossed the serious-visitor threshold — ${m.trigger || "?"}`,
  ui_proof_band_viewed: () => "Viewed the proof band",
};

export const VisitorActivity = ({ sid, api, authHeaders, onClose }) => {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    fetch(`${api}/admin/visitor-activity/${sid}`, { headers: authHeaders })
      .then((r) => r.json())
      .then((d) => setEvents(d.events || []))
      .catch(() => setEvents([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sid]);

  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-start justify-center p-6 overflow-y-auto" data-testid="visitor-activity-overlay">
      <div className="w-full max-w-xl rounded-2xl border border-[#2E2E2E] bg-[#111111] p-6 mt-10">
        <div className="flex items-baseline justify-between gap-4">
          <div>
            <p className="text-base font-bold text-white">Visitor activity</p>
            <p className="text-[14px] font-medium text-[#D6D6D6] mt-1 break-all" data-testid="visitor-activity-sid">Session {sid}</p>
          </div>
          <button onClick={onClose} data-testid="visitor-activity-close"
            className="text-[15px] font-semibold text-[#D6D6D6] hover:text-white shrink-0">Close</button>
        </div>
        <div className="mt-5 space-y-3 border-t border-[#2E2E2E] pt-4">
          {events === null && <p className="text-[15px] font-medium text-[#D6D6D6]">Loading…</p>}
          {events !== null && events.length === 0 && (
            <p className="text-[15px] font-medium text-[#D6D6D6]" data-testid="visitor-activity-empty">
              No recorded activity for this visitor session.
            </p>
          )}
          {(events || []).map((e, i) => (
            <div key={i} className="flex items-baseline gap-3" data-testid="visitor-activity-event">
              <span className="text-[14px] font-medium text-[#D6D6D6] shrink-0 w-20">
                {new Date(e.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
              </span>
              <span className="text-[15px] font-medium text-white">
                {(LABELS[e.type] || (() => e.type.replace("ui_", "").replaceAll("_", " ")))(e.meta || {})}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
